/**
 * WBS Parser Utility
 * Extracted from TeamGanttImporter.tsx
 * Handles Work Breakdown Structure (WBS) parsing and ID generation
 */

export interface WBSInfo {
  level: number;
  parts: number[];
  full?: string;
}

/**
 * Parse WBS number to determine hierarchy
 * WBS format: "1", "1.1", "1.1.1", etc.
 */
export function parseWBS(wbs: string): WBSInfo {
  if (!wbs || wbs.trim() === '') return { level: 0, parts: [] };
  const parts = wbs.toString().split('.');
  return {
    level: parts.length - 1,
    parts: parts.map(p => parseInt(p) || 0),
    full: wbs.toString()
  };
}

/**
 * Generate unique ID from WBS
 * Converts "1.2.3" to "teamgantt_1_2_3"
 */
export function generateId(wbs: string): string {
  return `teamgantt_${wbs.replace(/\./g, '_')}`;
}
